import axios from 'axios';
import { hashPassword } from '@shared/lib/security';
import api, { getApiBaseUrl, serverAddress } from '@shared/api/apiConfig';
import {
  authLoginURI,
  authRefreshTokenURI,
  authValidateTokenURI,
  userForgotPasswordURI,
  userPassCreateURI
} from '@shared/api/endpoints';
import { IResponse } from '../types';

export async function generateToken(username: string, password: string) {
  return api.post<{ accessKey: string; secretKey: string }, unknown>(authLoginURI, {
    accessKey: username,
    secretKey: await hashPassword(password)
  });
}

export async function refreshTokenCall(refreshToken?: string | null) {
  const response: IResponse<{ accessToken: string}> = await api.post(
    `${getApiBaseUrl()}${authRefreshTokenURI}`,
    refreshToken ? { refreshToken } : {},
    // {
    //   headers: { 'Content-Type': 'application/json' },
    //   withCredentials: true
    // }
  );
  return response;
}

export async function validateToken() {
  const response = await api.post(authValidateTokenURI, {});
  return response;
}

export async function resetPassword(body: Record<string, unknown>) {
  return axios.post(`${serverAddress}${userPassCreateURI}`, body);
}

export async function forgotPasswordLink(emailAddress: string) {
  return axios.get(`${serverAddress}${userForgotPasswordURI}?email=${encodeURIComponent(emailAddress)}`);
}
